<template>
  <div>
    <v-card tile>
      <v-card-title>
        <h3>Deposit</h3>
      </v-card-title>
      <v-divider></v-divider>

      <v-container>
        <v-layout row wrap>
          <v-text-field
            :disabled="!$can('edit', 'case-deposit')"
            label="Amount"
            v-model="deposit"
            prefix="$"
          >
            <template v-slot:append>
              <v-btn color="primary"
                     :disabled="!$can('edit', 'case-deposit')"
                     flat
                     :loading="loading"
                     @click="changeDeposit"
              >Save deposit and send receipt</v-btn>
            </template>
          </v-text-field>
        </v-layout>
      </v-container>
    </v-card>
    <v-card tile>
      <v-card-title>
        <h3>Left to Pay</h3>
      </v-card-title>
      <v-divider></v-divider>

      <v-container>
        <v-layout row wrap>
          <v-text-field
            :disabled="true"
            :value="leftToPay"
            label="Amount"
            prefix="$"
            class="disabled-active"
          />
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import plansAPI from '@/api/resources/plans'
  import casesAPI from '@/api/resources/cases'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      caseModel: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters({}),
      leftToPay () {
        return this.quotationTotalPrice - this.deposit
      }
    },
    data () {
      return {
        snackbar: false,
        loading: false,
        deposit: 0,
        quotationTotalPrice: 0,
        planData: {}
      }
    },
    watch: {
      timeStart (newVal) {
        if (newVal.indexOf(':') !== -1) {
          this.menuTimeStart.state = false
        }
      },
      caseModel (c) {
        this.deposit = c.deposit || 0
      }
    },
    methods: {
      changeDeposit () {
        this.loading = true
        this.$store.dispatch('updateCase', { case_id: this.caseModel.id, payload: { deposit: this.deposit } }).then(() => {
          this.$store.dispatch('getCaseInvoices', this.caseModel.id)
          this.$store.dispatch('getCaseLog', this.caseModel.id)
          this.loading = false
        })
      }
    },
    created () {
      plansAPI.loadPlan(this.caseModel.plans_id).then(result => {
        this.planData = result
      })

      casesAPI.getQuotationTotalPrice(this.caseModel.id).then(result => {
        this.quotationTotalPrice = result
      }, () => {})
    }
  }
</script>

<style>
  .disabled-active input {
    color: rgba(0,0,0,0.87) !important;
  }
</style>



// WEBPACK FOOTER //
// CaseDeposit.vue?311f3ae2